import { DOCUMENT } from "@angular/common";
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-register-step-3",
  templateUrl: "./register-step-3.component.html",
  styleUrl: "./register-step-3.component.scss",
  standalone: true,
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RegisterStep3Component {
  get windowLocationOrigin(): string {
    return this.document.location.origin;
  }

  get windowLocationHost(): string {
    return this.document.location.host;
  }

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {}

  navigateToMyAccount() {
    this.router.navigate(["/my-account"]);
  }

  closeWindow() {
    // Close the current window/tab
    this.document.defaultView?.close();
  }

  startTour() {
    // Start the tour
    const tourElement = this.document.querySelector("sdx-tour") as HTMLSdxTourElement;
    const sdxHeader = this.document.querySelector("sdx-header") as HTMLSdxHeaderElement;
    const sdxFooter = this.document.querySelector("sdx-footer") as HTMLSdxFooterElement;

    if (tourElement) {
      tourElement.steps = [
        {
          slot: "step1",
          element: sdxHeader
        },
        {
          slot: "step2",
          element: sdxHeader
        },
        {
          slot: "step3",
          element: sdxFooter
        }
      ];
      tourElement.open();
    }
  }
}
